export default __webpack_public_path__ + "static/media/Sword guard.88e3c609.jpg";